<template>
  <v-card>
    <v-container grid-list-sm fluid>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6 md6 offset-sm3>
          <v-list two-line>
            <template v-for="(file, f_index) in this.scanItems">
              <v-list-tile :key="file.id" avatar @click="openDialog(file)">
                <v-list-tile-avatar>
                  <v-icon large color="red">description</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="file.name"></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="file.created_at"
                  ></v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    v-html="file.description"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn
                    icon
                    ripple
                    :disabled="deletings.indexOf(file.id) > -1"
                    @click.stop="deleteDialog(file)"
                  >
                    <template v-if="deletings.indexOf(file.id) < 0">
                      <v-icon color="grey lighten-1">delete</v-icon>
                    </template>
                    <template v-else>
                      <template slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                      </template>
                    </template>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="f_index < scanItems.length - 1"
                :key="f_index"
              ></v-divider>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <v-textarea
            solo
            name="description"
            label="Description"
            v-model="dialogFile.description"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" fab bottom left dark @click="closeDialog"
            ><v-icon>close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="green" fab bottom right dark @click.native="saveMedia()"
            ><v-icon>save</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <delete-dialog
      preset="delete"
      ref="deleteDialog"
      v-on:deleted="deleteScanConfirmed"
    ></delete-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Dialog from './Dialog'
export default {
  name: 'ScanCall',
  components: { 'delete-dialog': Dialog },
  props: ['scanItems'],
  data() {
    return {
      dialog: false,
      dialogFile: {},
      deleteDialogFlag: false,
      deletings: []
    }
  },
  computed: {
    ...mapGetters({
      activeCallId: 'calls/activeCallId'
    })
  },
  mounted() {
    this.readCalls()
  },
  methods: {
    ...mapActions({
      readCalls: 'calls/readCalls',
      readCall: 'calls/readCall',
      addMedia: 'calls/addMedia',
      deleteMedia: 'calls/deleteMedia',
      updateMedia: 'calls/updateMedia'
    }),
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),

    openDialog(file) {
      this.dialog = true
      this.dialogFile = _.clone(file, {})
    },

    closeDialog(file) {
      this.dialog = false
      this.dialogFile = {}
    },
    // Show delete dialog
    deleteDialog(file) {
      this.$refs.deleteDialog.open(file)
    },
    // Delete confirmed
    deleteScanConfirmed(media) {
      media.collection_name = 'scans'
      if (this.deletings.indexOf(media.id) < 0) this.deletings.push(media.id)
      this.deleteMedia(media)
        .then(() => {
          // this.readCall(media.model_id)
          this.setNotification(this.$vuetify.t('$vuetify.calls.scanDeleted'))
          this.$emit('scan-deleted', media)
        })
        .catch(error => {
          this.setNotification('Error happened. Please kindly try again later!')
          const that = this
          setTimeout(() => {
            const index = that.deletings.indexOf(media.id)
            if (index > -1) {
              that.deletings.splice(index, 1)
            }
          }, 1000)
        })
    },
    saveMedia() {
      const media = this.dialogFile
      // media.description = this.description
      this.updateMedia({
        media: media,
        collection_name: 'scans',
        params: {
          description: this.dialogFile.description
        }
      }).then(() => {
        this.setNotification(this.$vuetify.t('$vuetify.calls.mediaUpdated'))
        this.dialog = false
      })
    }
  }
}
</script>

<style scoped>
.media {
  cursor: pointer;
}
.v-list__tile__action--stack {
  align-items: center;
  flex-direction: row;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
